import { render, staticRenderFns } from "./AtestadoView.vue?vue&type=template&id=7cac29fb&"
import script from "./AtestadoView.vue?vue&type=script&lang=js&"
export * from "./AtestadoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports